export default __webpack_public_path__ + "static/media/bg_tracking.dfa14b2c.png";